var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"manyan",staticClass:"container-code-item container-manyan",style:(_vm.styles)},[_vm._l((_vm.detail.banner),function(item,index){return [(_vm.active===index)?_c('img',{key:index,attrs:{"src":item.img,"alt":""}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }